import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { BebopWhiteIcon } from "components/Icons";
import { useIsMobile } from "hooks/useDeviceType";
import { withIsVisible } from "utils/reactUtils";
import { Navbar } from "./Navbar/Navbar";

interface HeaderProps {
  setIsSideNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Header = withIsVisible(({ setIsSideNavOpen }: HeaderProps) => {
  const isMobile = useIsMobile();
  const lastScroll = useRef<number>(0);
  const headerRef = useRef<HTMLDivElement | null>(null);

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", handleStickyHeader);
    return () => {
      window.removeEventListener("scroll", handleStickyHeader);
    };
  });

  /* Method that will fix header after a specific scrollable */
  const handleStickyHeader = () => {
    if (headerRef.current == null) return;
    const scrollTop = window.scrollY;
    if (scrollTop < lastScroll.current) {
      headerRef.current.style.top = "0";
    } else if (scrollTop > lastScroll.current) {
      headerRef.current.style.top = `-${headerRef.current.clientWidth}px`;
    }

    lastScroll.current = scrollTop;
  };

  return (
    <HeaderContainer ref={headerRef} isMobile={isMobile}>
      <Contents>
        <Link to="/">
          <BebopWhiteIcon height={isMobile ? 26 : 40} />
        </Link>
        <Navbar setIsSideNavOpen={setIsSideNavOpen} />
      </Contents>
    </HeaderContainer>
  );
});

const HeaderContainer = styled.nav<{ isMobile: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${props => props.theme.surface.alt.primary.default};
  position: sticky;
  width: 100%;
  padding: ${props => (props.isMobile ? "13px 24px" : "24px 72px")};
  top: 0;
  z-index: 2;
  transition:
    background-color 0.2s linear,
    top 0.5s ease-out;
`;

const Contents = styled.div`
  width: 100%;
  max-width: 2000px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
